import React from 'react';
import {PageFlip, Page, Cover} from '../components/PageFlip';
import {obterContratoPeloNumero} from '../actions/ContratoActions';
import {obterPublicacoesPeloTipo} from '../actions/PublicacaoActions';
import {cadastrarAcao} from '../actions/AcaoActions';
import {connect} from 'react-redux';
import {FTP_URL} from '../config/urls';

class ContratoPublicacao extends React.Component {
  state = {
    pagina: 0,
    paginas: [],
    remover: [],
    editar: [],
    historico: {},
    aprovar: [],
    estornar: [],
    paginaHistorico: null,
    carregando: false,
    renderPageFlip:false,
    ultimaPub:{},
    lente: false,
    expandImagem: false,
    backgroundImage: "",
    backgroundPosition: '0% 0%',
    imagemSelecionada: ""
  }

  componentWillMount(){
    document.addEventListener('keydown', this.onKeyPress);
    this.obterPublicacoes();
  }

  obterPublicacoes(){
    this.props.obterContratoPeloNumero(this.props.match.params.id).then(() => {
      let tipo = "";
      switch(this.props.match.params.tipo){
        case 'paginacao':
          tipo = "Paginação";
          break;
        case 'capa-dura':
          tipo = "Capa Dura";
          break;
        case 'embalagens':
          tipo = "Embalagem";
          break;
        case 'encarte':
          tipo = "Encarte";
          break;
        case 'convite-simples':
          tipo = "Convite Simples";
          break;
        case 'senha-de-entrada':
          tipo = "Senha de Entrada";
          break;
        case 'missal':
          tipo = "Missal";
          break;
        case 'outros-produtos':
          tipo = "Outros Produtos";
          break;
        case 'personalizadas':
          tipo = "Personalizadas";
          break;
      }
      this.props.obterPublicacoesPeloTipo(tipo, this.props.contrato.id).then(() => {
        let publicacoes = this.props.publicacoes;
        let todasPaginas = {};
        publicacoes = publicacoes.filter(publicacao => publicacao.visivel);
        publicacoes.sort((a, b)=>{return new Date(b.dataPublicacao).getTime() - new Date(a.dataPublicacao).getTime()});
        //salva qual a ultima publicação pra editar mais tarde
        this.setState({ultimaPub:publicacoes[0]});
        publicacoes.forEach(publicacao => {
          publicacao.paginas.forEach(pagina => {
            if(!todasPaginas[pagina.nome]){
              todasPaginas[pagina.nome] = [];
            }
            if(publicacao.bloqueada || publicacao.dataAprovacao){
              pagina.bloqueada = true;
            }else{
              pagina.bloqueada = false;
            }
            todasPaginas[pagina.nome].push(pagina);
          });
        });
        let paginas = [];
        let historico = {};
        Object.values(todasPaginas).forEach(paginasArray => {
          paginas.push(paginasArray[0]);
        });
        for(var key in todasPaginas){
          todasPaginas[key].shift();
        }
        for(var key in todasPaginas){
          if(todasPaginas[key].length>0){
            historico[key] = todasPaginas[key];
          }
        }
        paginas.sort((a, b) => a.tipo - b.tipo);
        paginas.sort((a, b) => a.numero - b.numero);
        this.setState({paginas, historico});
        setTimeout(()=>this.setState({renderPageFlip:true}), 500);
      });
    });
  }

  componentDidUpdate(){
    let alfinetes = Array.from(document.querySelectorAll('.alfinete'));
    alfinetes.forEach(alfinete => {
      alfinete.parentNode.removeChild(alfinete);
    });
    this.state.paginas.forEach(pagina => {
      pagina.comentarios.forEach((comentario, i) => {
        let imagem = document.querySelector(`#pagina${pagina.id}`);
        let wrapper = document.createElement('div');
        wrapper.style.position = "absolute";
        wrapper.style.left = `calc(${comentario.posX})`;
        wrapper.style.top = `calc(${comentario.posY})`;
        wrapper.style.fontFamily = "Arial, Helvetica, sans-serif";
        wrapper.innerHTML = `<p style="color: #bbb; background-color: rgba(0,0,0,1); padding: 2px 8px; border-radius: 25px; position: absolute">${i + 1}</p>`;
        let alfinete = document.createElement('img');
        alfinete.style.position = "absolute";
        alfinete.style.bottom = "0px";
        alfinete.style.left = "-2px";
        alfinete.src = "/images/pin-icon.png";
        alfinete.style.width = "25px";
        wrapper.classList.add("alfinete");
        wrapper.appendChild(alfinete);
        imagem.appendChild(wrapper);
        let self = this;
        alfinete.onclick = function(){
          if (self.state.ultimaPub.dataAprovacao === null) {
            self.setState({lente: true}, () => {
              self.refs[pagina.id+'_'+comentario.posX+'_'+comentario.posY].focus();
              self.refs[pagina.id+'_'+comentario.posX+'_'+comentario.posY].parentNode.parentNode.scrollIntoView({block: 'end', behavior: 'smooth'});
              self.refs[pagina.id+'_'+comentario.posX+'_'+comentario.posY].parentNode.parentNode.parentNode.style.zIndex = 5;
            });
          }
        }
      });
    });
  }

  handleMouseMove = e => {
    const { left, top, width, height } = e.target.getBoundingClientRect();
    const x = (e.pageX - left) / width * 100;
    const y = (e.pageY - top) / height * 100;
    this.setState({ backgroundPosition: `${x}% ${y}%`, backgroundImage: this.state.imagemSelecionada });
  }

  removerBackgroundImg () {
    document.querySelector("#figura-expandImg").style.backgroundImage = "";
  }

  adicionarBackgroundImg () {
    document.querySelector("#figura-expandImg").style.backgroundImage = this.state.imagemSelecionada;
  }

  onKeyPress = (event) => {
    switch (event.key) {
      case 'ArrowLeft':
        this.voltarPagina();
        break;
      case 'ArrowRight':
        this.proximaPagina();
        break;
    }
  }

  proximaPagina () {
    if (this.state.pagina < this.state.paginas.length - 1 && this.state.pagina + 1 !== undefined) {
      this.setState({pagina: this.state.pagina + 1});
    }
  }

  voltarPagina () {
    if (this.state.pagina > 0 && this.state.pagina - 1 !== undefined) {
      this.setState({pagina: this.state.pagina - 1});
    }
  }

  render () {
    const pagina = this.state.paginas[this.state.pagina] ? this.state.paginas[this.state.pagina] : null;
    if(this.state.paginas.length === 0){
      return <div>Aguarde...</div>
    }
    return(
      <div style={{position: "relative"}}>
        <div className="box box-solid" style={{position: "relative", backgroundColor: "white"}}>
          <div className="box-body">
            <div className="col-md-8 col-sm-12 col-xs-12" style={{textAlign: "center", marginBottom: 25}}>
              {
                this.state.paginas.map((pagina, i) => (
                  <div key={i} style={{padding: 0, display: pagina.id === this.state.paginas[this.state.pagina].id ? "" : "none"}}>
                    <h3 style={{marginTop: 0, marginBottom: 10, textTransform: "uppercase", fontWeight: 100}}>{`${pagina.tipo} - Página ${pagina.numero}`}</h3>
                    <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                      <div style={{width: "fit-content", boxShadow: "4px 4px 15px rgba(0, 0, 0, .24)"}}>
                        <div id={`pagina${pagina ? pagina.id : ""}`} style={{width: "fit-content", textAlign: "center", height: "100%", position: "relative"}}>
                          <img src={pagina ? `${FTP_URL}${pagina.publicacao}/${pagina.nome}` : null} style={{maxHeight: 600}} />
                        </div>
                      </div>
                    </div>
                    <i className="fa fa-expand" data-target="#expand" data-toggle="modal" style={{color: "#333", fontSize: 18, marginTop: 8, cursor: "pointer"}}></i>
                    <i className="fa fa-search-plus hidden-xs hidden-sm" data-target="#expandImg" data-toggle="modal" onClick={() => {this.setState({imagemSelecionada: `url(${FTP_URL}${pagina.publicacao}/${pagina.nome})`})}} style={{color: "#333", fontSize: 18, marginTop: 8, cursor: "pointer", marginLeft: 25}}></i>
                    <i className="fa fa-book hidden-md hidden-sm hidden-xs" data-target="#modal-pageflip" data-toggle="modal" style={{color:"#333", fontSize: 18, marginTop: 8, cursor: "pointer", marginLeft: 25}}></i>
                  </div>
                ))
              }
            </div>
            <div className="col-xs-12 col-sm-12 col-md-4" style={{position: "relative", marginBottom: 25}}>
              <div style={{textAlign: "center", backgroundColor: "white", maxHeight: 650, display: "flex", flex: 1, flexDirection: "column", alignItems: "center", boxShadow: "4px 4px 15px rgba(0,0,0,.24)"}}>
                <div style={{flex: 1, overflowY: 'auto', width: "100%"}}>
                  {
                    pagina && pagina.comentarios.length === 0 && pagina.aprovada ?
                      <h4 style={{margin: "5px 0px"}}>Página aprovada em {new Date(pagina.dataAprovacao).toLocaleDateString('pt-BR', {timeZone: 'UTC'})}</h4>
                    : pagina && !pagina.aprovada ? 
                      pagina.comentarios.length > 0 ?
                        <React.Fragment>
                          <h3 style={{margin: "15px 0px 10px", fontWeight: 600}}>CORREÇÕES</h3>
                          <div style={{flex: 1, overflowY: "auto", width: "100%", height: "auto", maxHeight: 480, padding: "0px 20px"}} >
                            {
                              pagina.comentarios.map((comentario, i) => (
                                <div key={i} className="box box-success" style={{display: "block !important", border: "0 none", borderRadius: 0, boxShadow: "0 0 0 0"}}>
                                  <div className="box-header" style={{padding: "10px 10px 0px"}}>
                                    <h3 className="box-title">Correção {i + 1}</h3>
                                  </div>
                                  <div className="box-body" style={{padding: "0px 5px"}}>
                                    <div><textarea disabled ref={`${pagina.id}_${comentario.posX}_${comentario.posY}`} style={{maxWidth: "100%", width: "100%", minWidth: "100%"}}>{comentario.texto}</textarea></div>
                                  </div>
                                </div>
                              ))
                            }
                          </div>
                        </React.Fragment>
                      : <h4 style={{margin: "5px 0px"}}>Página aberta</h4>
                    : null
                  }
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-md-12 col-sm-12">
              <div>
                <div style={{width: "100%", display: "flex", flexDirection: "row", overflowX: "scroll", backgroundColor: "rgb(34, 45, 50)", padding: 15}}>
                  {
                    this.state.paginas.map((pa, i) => ((
                        <div key={i} style={{width: "auto", padding: 10, textAlign: "center"}}>
                          <div onClick={() => this.setState({pagina: i})} style={{position: "relative", height: 100, cursor: "pointer"}}>
                            {
                              pa.aprovada ?
                              (
                                <div style={{backgroundColor: "rgba(0, 0, 0, 0.6)", position: "absolute", left: `0`, top: `0`, height: "100%", width: "100%", zIndex: 2, transform: pa.id===this.state.paginas[this.state.pagina].id ? "scale(1.2)" :""}}>
                                  <i className="fa fa-check" style={{color: "#00a65a", fontSize: 36, position: "absolute", left: "calc(50% - 18px)", top: "calc(50% - 18px)"}}></i>
                                </div>
                              ) : null
                            }
                            <img src={`${FTP_URL}${pa.publicacao}/${pa.nome}`} style={{borderWidth: 1, borderColor: "black", height: "100%",transform: pa.id===this.state.paginas[this.state.pagina].id ? "scale(1.2)" :""}} />
                          </div>
                        </div>
                      )
                    ))
                  }
                </div>
              </div>
            </div>
          </div>
          <div className="modal fade in" id="expand">
            <div className="modal-dialog modal-lg" style={{width:"90%"}}>
              <div className="modal-content">
                <div className="modal-header">
                  <button type="button" className="close" data-dismiss="modal" aria-label="close">
                    <i className="fa fa-times"></i>
                  </button>
                </div>
                <div className="modal-body">
                  {
                    this.state.paginas.map((pagina, i) => (
                      <div key={i} style={{backgroundColor: "#222d32", padding: 25, display: pagina.id===this.state.paginas[this.state.pagina].id ? "" : "none"}}>
                        <h3 style={{color: "white", marginTop: -10}}>{`${pagina.tipo} - Página ${pagina.numero}`}</h3>
                        <div style={{display: 'flex', flex: 1, justifyContent: "center", flexDirection: 'row', alignItems: "center"}}>
                          <div id={`pagina${pagina ? pagina.id : ""}`} style={{width: "fit-content", textAlign: "center", height: "100%", position: "relative"}}>
                            <img id="pagina-parametro" src={pagina ? `${FTP_URL}${pagina.publicacao}/${pagina.nome}` : null} style={{maxWidth: "100%"}} />
                          </div>
                        </div>
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>
          </div>
          <div className="modal fade in" id="modal-pageflip">
            <div className="modal-dialog modal-lg" style={{width:"90%"}}>
              <div className="modal-content">
                <div className="modal-header">
                  <button type="button" className="close" data-dismiss="modal" aria-label="close">
                    <i className="fa fa-times"></i>
                  </button>
                </div>
                <div className="modal-body">
                  {
                  this.state.renderPageFlip ?
                  <PageFlip>
                    {
                      this.state.paginas.map((pagina, i) => {
                        if(pagina.tipo === "Vegetal"){
                          return [
                            <Page key={i} isVegetal={true}>
                              <img style={{width:"100%",opacity: 0.8}} src={pagina ? `${FTP_URL}${pagina.publicacao}/${pagina.nome}` : null} />
                            </Page>,
                            <Page key={i+"_1"} isVegetal={true}>
                              <img style={{width:"100%", WebkitTransform: "scaleX(-1)", transform: "scaleX(-1)", filter: "FlipH", msFilter: "FlipH", opacity: 0.8}} src={pagina ? `${FTP_URL}${pagina.publicacao}/${pagina.nome}` : null} />
                            </Page>
                          ]
                        }else{
                          return (
                            <Page key={i} isVegetal={false}>
                              <img style={{width:"100%"}} src={pagina ? `${FTP_URL}${pagina.publicacao}/${pagina.nome}` : null} />
                            </Page>
                          )
                        }
                      })
                    }
                  </PageFlip>
                  :<div>Aguarde...</div>
                }
                </div>
              </div>
            </div>
          </div>
          <div className="modal fade in" id="expandImg" style={{padding: 0}}>
            <div className="modal-dialog modal-lg" style={{width:"100vw", height: "100vh", display: "flex", flexDirection: "column", padding: "30px", margin: 0}}>
              <div style={{display: "flex", justifyContent: "space-between", marginBottom: 30}}>
                <h3 style={{color: "#fff", fontWeight: 600}}>{`${pagina.tipo} - Página ${pagina.numero}`}</h3>
                <button type="button" className="close" data-dismiss="modal" aria-label="close" style={{color: "#fff", opacity: 1}}><i className="fa fa-times"></i></button>
              </div>
              <h5 style={{textAlign: "center", color: "#fff"}}>Passe o mouse pela imagem</h5>
              <figure id="figura-expandImg" onMouseEnter={this.adicionarBackgroundImg.bind(this)} onMouseLeave={this.removerBackgroundImg.bind(this)} onMouseMove={this.handleMouseMove.bind(this)} style={{backgroundImage: this.state.backgroundImage, backgroundPosition: this.state.backgroundPosition}}>
                <img src={`${FTP_URL}${pagina.publicacao}/${pagina.nome}`}/>
              </figure>
            </div>
          </div>
        </div>
        <div onClick={() => {this.setState({lente: false})}} style={{display: (this.state.lente ? "block" : "none"), position: "absolute", backgroundColor: "rgba(0,0,0,.8)", width: "100%", height: "100%", top: "0px", left: "0px", zIndex: 2}}></div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    publicacao: state.publicacao.especifica,
    contrato: state.contrato.especifico,
    autenticado: state.usuario.autenticado,
    publicacoes: state.publicacao.todas
  }
}

export default connect(mapStateToProps, {cadastrarAcao, obterContratoPeloNumero, obterPublicacoesPeloTipo})(ContratoPublicacao);



// WEBPACK FOOTER //
// ./src/views/ContratoPublicacao.js